import {httpDelete, httpGet, httpPost} from './http.service';
import {ICodebook, ICodebookDTO, ICodebookEntry} from '../incase-domain/codebook';
import {IPaginatedResult} from '../incase-domain/search';

export const uploadCodebook = (codebookDTO: ICodebookDTO): Promise<boolean> => {
    const formData = new FormData();
    formData.append('file', codebookDTO.file);
    formData.append('codebookName', codebookDTO.codebookName);
    formData.append('availableInMultiselect', codebookDTO.availableInMultiselect.toString());

    return httpPost('editor/codebook/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const fetchCodebookEntries = (
    id: string,
    page: number,
    size: number,
    searchString?: string
): Promise<IPaginatedResult<ICodebookEntry>> => {
    return httpGet(`editor/codebook/${id}/entries?page=${page}&size=${size}${searchString ? `&searchString=${searchString}` : ''}`);
};

export const fetchCodebooks = (availableInMultiselect?: boolean): Promise<ICodebook[]> => {
    return httpGet(`editor/codebook${availableInMultiselect ? '?availableInMultiselect=true' : ''}`);
};

export const updateCodebook = (codebook: Partial<ICodebook>): Promise<ICodebook> => {
    return httpPost(`editor/codebook/${codebook._id}`, codebook);
};

export const deleteCodebook = (id: string): Promise<boolean> => {
    return httpDelete(`editor/codebook/${id}`, {});
};
